import { processData } from '../data/processData';
import ContinentComponent from '../components/Destinations/ContinentComponent';
import { useEffect } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';

const DestinationsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const processedData = processData();

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Explore Top Holiday Destinations | Halo Holidays</title>
          <meta name="description" content="Discover inspiring destinations around the world with Halo Holidays. From tropical beaches to vibrant cities, find your perfect getaway." />
        </Helmet>
      </HelmetProvider>
      <div className="container mx-auto p-4">
        <h1 className="text-3xl font-bold mb-4 text-center">Explore Our Destinations</h1>
        <hr className="mt-10 mb-4" />
        {processedData.map((continent, index) => (
          <ContinentComponent key={index} continent={continent} />
        ))}
      </div>
    </>
  );
};

export default DestinationsPage;
